
import axios from "axios";

// export const BaseUrl = "http://localhost:5087/api/";
// export const BaseUrl = "https://oryxb.gunvortech.com/api/";
// export const BaseUrl = "https://dawliyaeb.gunvortech.com/api/";
// export const BaseUrl = "https://filsgiftb.gunvortech.com/api/";
// export const BaseUrl = "https://indiacb.gunvortech.com/api/";
// export const BaseUrl = "https://fbgarmentsb.gunvortech.com/api/";
// export const BaseUrl = "https://prestigefb.gunvortech.com/api/";
// export const BaseUrl = "https://nakhabsmb.gunvortech.com/api/";
// export const BaseUrl = "https://alphapb.gunvortech.com/api/";
// export const BaseUrl = "https://dukkanb.gunvortech.com/api/";
// export const BaseUrl = "https://smoonb.gunvortech.com/api/";
export const BaseUrl = "https://t2back.gunvortech.com/api/";
// export const BaseUrl = "https://qaelectricb.gunvortech.com/api/";
// export const BaseUrl = "https://lhomesb.gunvortech.com/api/";
// export const BaseUrl = "https://lphoneb.gunvortech.com/api/";
// export const BaseUrl = "https://hfashionb.gunvortech.com/api/";
// export const BaseUrl = "https://hgiftb.gunvortech.com/api/";
// export const BaseUrl = "https://hafezb.gunvortech.com/api/";
// export const BaseUrl = "https://colorsb.gunvortech.com/api/";

// Axios response interceptor — detect network failures & 500 errors
axios.interceptors.response.use(
  (response) => {
    if (response.status >= 500) {
      window.dispatchEvent(
        new CustomEvent("server-error", { detail: { type: "server" } }),
      );
    }
    return response;
  },
  (error) => {
    if (!error.response) {
      // Network error — server unreachable or no internet
      window.dispatchEvent(
        new CustomEvent("server-error", { detail: { type: "network" } }),
      );
    } else if (error.response.status >= 500) {
      window.dispatchEvent(
        new CustomEvent("server-error", { detail: { type: "server" } }),
      );
    }
    return Promise.reject(error);
  },
);

export const controller = {
  User: "User",
  UserRole: "UserRole",
  Auth: "Auth",
  // SMTP + two-factor administration. System Engineer tier only, enforced server-side.
  PlatformSecurity: "PlatformSecurity",
  // Desktop app: monitoring, setup keys, disconnect. System Engineer tier only,
  // enforced server-side by UserTiers.IsEngineer rather than an access flag.
  PosDevice: "PosDevice",
  Org: "Org",
  Outlet: "Outlet",
  Tax: "Tax",
  City: "City",
  PayType: "PayType",
  CstmrGroup: "CstmrGroup",
  Customer: "Customer",
  CustomerVehicle: "CustomerVehicle",
  CustomerBranch: "CustomerBranch",
  VehicleBrand: "VehicleBrand",
  Service: "Service",
  ServiceCategory: "ServiceCategory",
  ServiceBay: "ServiceBay",
  ServiceDiscountType: "ServiceDiscountType",
  Employee: "Employee",
  Category: "Category",
  Supplier: "Supplier",
  Brand: "Brand",
  Tag: "Tag",
  Product: "Product",
  PosCatalog: "PosCatalog",
  // The "Select items" dialog on Quotes / Direct Invoicing (components/ProductMultiPicker).
  ProductPicker: "ProductPicker",
  ProdAttr: "ProdAttr",
  Stock: "Stock",
  PurchaseInvoice: "PurchaseInvoice",
  Inventory: "Inventory",
  Register: "Register",
  SellReg: "SellReg",
  Sell: "Sell",
  SalesOrder: "SalesOrder",
  // Installment (layaway) sales: a deposit held, goods reserved, sold at collection.
  Installment: "Installment",
  SalesInvoice: "SalesInvoice",
  CashMgmt: "CashMgmt",
  ParkSale: "ParkSale",
  UserCheckInOut: "UserCheckInOut",
  QuoteSale: "QuoteSale",
  CustomerTxn: "CustomerTxn",
  // Cart-line purchase history for the selected customer (POS, Sales Invoice).
  CustomerItemHistory: "CustomerItemHistory",
  SellReturn: "SellReturn",
  HomeReport: "HomeReport",
  SupplierTxn: "SupplierTxn",
  StockReturn: "StockReturn",
  Report: "Report",
  StockReport: "StockReport",
  LogReport: "LogReport",
  PrintLabel: "PrintLabel",
  FollowUpType: "FollowUpType",
  InqSrc: "InqSrc",
  Inquiry: "Inquiry",
  FollowUp: "FollowUp",
  Currency: "Currency",
  Expense: "Expense",
  ExpenseType: "ExpenseType",
  FiscalYear: "FiscalYear",
  InventoryCount: "InventoryCount",
  SalesReport: "SalesReport",
  PaymentReport: "PaymentReport",
  SalesSummary: "SalesSummary",
  BusinessActivity: "BusinessActivity",
  Enum: "Enum",
  Company: "Company",
  TimeZone: "TimeZone",
  Ledger: "Ledger",
  Coa: "Coa",
  AccountMapping: "AccountMapping",
  JournalEntry: "JournalEntry",
  JournalVoucher: "JournalVoucher",
  StockTransfer: "StockTransfer",
  StockTransferRequest: "StockTransferRequest",

  InventoryAdjustment: "InventoryAdjustment",
  InventoryCost: "InventoryCost",
  PriceCategory: "PriceCategory",
  AccountTransfer: "AccountTransfer",
  BankAccount: "BankAccount",
  CashSafe: "CashSafe",
  BranchCashSafe: "BranchCashSafe",
  BankReconciliation: "BankReconciliation",
  UnitCategory: "UnitCategory",
  Unit: "Unit",
  Commission: "Commission",
  Coupon: "Coupon",
  PromotionApproval: "PromotionApproval",
  ServiceContract: "ServiceContract",
  ScaleBarcode: "ScaleBarcode",
  InvoiceTemplate: "InvoiceTemplate",
  BusinessHours: "BusinessHours",
};

export const action = {
  // ---- Desktop app (erp.desktop) ----
  Console: "/Console",
  SetupOptions: "/SetupOptions",
  StepUpRequirement: "/StepUpRequirement",
  SendStepUpCode: "/SendStepUpCode",
  IssueSetupKey: "/IssueSetupKey",
  CancelSetupKey: "/CancelSetupKey",
  UpdateDetails: "/UpdateDetails",
  Revoke: "/Revoke",
  Suspend: "/Suspend",
  Resume: "/Resume",
  AcknowledgeFingerprint: "/AcknowledgeFingerprint",
  RevealEscrowedKey: "/RevealEscrowedKey",
  Archive: "/Archive",
  Restore: "/Restore",
  DeleteDevice: "/Delete",
  HeldDocuments: "/HeldDocuments",
  HeldDocument: "/HeldDocument",
  DiscardHeldDocument: "/DiscardHeldDocument",
  SupplierDue: "/SupplierDue",
  AccountStatement: "/AccountStatement",
  ExportStatement: "/ExportStatement",
  ExportStatementPdf: "/ExportStatementPdf",
  BizContextDetails: "/BizContextDetails",
  GetSpecificProd: "/GetSpecificProd",
  ExportStockMovement: "/ExportStockMovement",
  ExportStockMovementPdf: "/ExportStockMovementPdf",
  ExportOrderPdf: "/ExportOrderPdf",
  ExportReceivePdf: "/ExportReceivePdf",
  CreateReceipt: "/CreateReceipt",
  VoidReceipt: "/VoidReceipt",
  CloseShort: "/CloseShort",
  GetReceiptsByPo: "/GetReceiptsByPo",
  GetReceiptById: "/GetReceiptById",
  GetReceivablePos: "/GetReceivablePos",
  GetAllReceipts: "/GetAllReceipts",
  ExportGrnPdf: "/ExportGrnPdf",

  // Stock transfer workflow: request -> dispatch -> receive -> settle.
  // CloseShort above is shared with the purchase side; both post ParamDto.
  Dispatch: "/Dispatch",
  Receive: "/Receive",
  ResolveShortfall: "/ResolveShortfall",
  GetReceivableById: "/GetReceivableById",
  GetDispatchableById: "/GetDispatchableById",
  GetDispatchableRequests: "/GetDispatchableRequests",
  PendingCount: "/PendingCount",
  ExportTransferNotePdf: "/ExportTransferNotePdf",
  ExportGoodsReceivedNotePdf: "/ExportGoodsReceivedNotePdf",
  ExportStockRequestPdf: "/ExportStockRequestPdf",

  StockMovement: "/StockMovement",
  Export: "/Export",
  CountByStatus: "/CountByStatus",
  ExportVouchers: "/ExportVouchers",
  ExportVouchersPdf: "/ExportVouchersPdf",
  ExportVoucher: "/ExportVoucher",
  ExportVoucherPdf: "/ExportVoucherPdf",
  GetLastJvId: "/GetLastJvId",
  // The JV date picker's outer bounds (opening to closing day of the open fiscal years)
  GetVoucherDateWindow: "/GetVoucherDateWindow",
  ExportSalesHistory: "/ExportSalesHistory",
  GetAllByInq: "/GetAllByInq",
  GetLabelsByCo: "/GetLabelsByCo",
  ExportJournalEntries: "/ExportJournalEntries",
  GetHierarchyByLedger: "/GetHierarchyByLedger",
  CustomerSubledgerPanel: "/CustomerSubledgerPanel",
  SupplierSubledgerPanel: "/SupplierSubledgerPanel",
  SubledgerReconciliation: "/SubledgerReconciliation",
  // Why the GL control account and the customer / supplier ledgers differ (read-only).
  SubledgerDrift: "/SubledgerDrift",
  GetUnmappedAccLabelByLedger: "/GetUnmappedAccLabelByLedger",
  ExportMapping: "/ExportMapping",
  IsTxnExist: "/IsTxnExist",
  IsCodeExist: "/IsCodeExist",
  GetParentLabelsByLedger: "/GetParentLabelsByLedger",
  GetParentLabelsByCompany: "/GetParentLabelsByCompany",
  GetAllByCompany: "/GetAllByCompany",
  GetLabelsByCompany: "/GetLabelsByCompany",
  GetPostableLabels: "/GetPostableLabels",
  GetCashBankLabels: "/GetCashBankLabels",
  GetExpenseLabels: "/GetExpenseLabels",
  GetExpenseGroupLabels: "/GetExpenseGroupLabels",
  GetCashBankSummary: "/GetCashBankSummary",
  GetAccountTransactions: "/GetAccountTransactions",
  ExportAccountTransactions: "/ExportAccountTransactions",
  SuggestNextCode: "/SuggestNextCode",
  GetAllByLedger: "/GetAllByLedger",
  ExportChartOfAccounts: "/ExportChartOfAccounts",
  GenerateDefaultCoaByLedger: "/GenerateDefaultCoaByLedger",
  ExportLedgers: "/ExportLedgers",
  CompanyLedgers: "/CompanyLedgers",
  ExportCompanies: "/ExportCompanies",
  GetEnum: "/GetEnum",
  GetDetailsWithWorkTimes: "/GetDetailsWithWorkTimes",
  TaxReport: "/TaxReport",
  ExportSells: "/ExportSells",
  GetSells: "/GetSells",
  PrintDetails: "/PrintDetails",
  ExportReport: "/ExportReport",
  GenerateReport: "/GenerateReport",
  TypesOfReports: "/TypesOfReports",
  TotalAccounts: "/TotalAccounts",
  CompleteCount: "/CompleteCount",
  DiscardCount: "/DiscardCount",
  ResetCounts: "/ResetCounts",
  IncludeExcludeCounts: "/IncludeExcludeCounts",
  DeleteCountedItem: "/DeleteCountedItem",
  CalcTotalItems: "/CalcTotalItems",
  GetAllItems: "/GetAllItems",
  GetCountedItems: "/GetCountedItems",
  GetUncountedItems: "/GetUncountedItems",
  GetMatchedItems: "/GetMatchedItems",
  GetUnmatchedItems: "/GetUnmatchedItems",
  GetExlculedItems: "/GetExlculedItems",
  GetLastCounts: "/GetLastCounts",
  PostCount: "/PostCount",
  GetDetails: "/GetDetails",
  TypesOfCountsMade: "/TypesOfCountsMade",
  LockAndFinalized: "/LockAndFinalized",
  DueCounts: "/DueCounts",
  UpcomingCounts: "/UpcomingCounts",
  CompletedCounts: "/CompletedCounts",
  CanceledCounts: "/CanceledCounts",
  CloseFiscalYear: "/CloseFiscalYear",
  SaveSnapshot: "/SaveSnapshot",
  TakeSnapshot: "/TakeSnapshot",
  NewYearDefaults: "/NewYearDefaults",
  ExportFiscalYears: "/ExportFiscalYears",
  ExportFiscalYearsPdf: "/ExportFiscalYearsPdf",
  ExpAccounts: "/ExpAccounts",
  ExportExpAccounts: "/ExportExpAccounts",
  ExportExpense: "/ExportExpense",
  ExportBankAccounts: "/ExportBankAccounts",
  ExportBankAccountsPdf: "/ExportBankAccountsPdf",
  // Cash Safe
  GetLedger: "/GetLedger",
  GetCounts: "/GetCounts",
  Deposit: "/Deposit",
  Withdraw: "/Withdraw",
  Transfer: "/Transfer",
  // PostCount is already defined above (inventory count) with the same value — reused.
  ReverseTxn: "/ReverseTxn",
  Recalculate: "/Recalculate",
  GetMySafes: "/GetMySafes",
  // Safe balance pill on /close_reg. Gated on pos.viewCashSafeBalance, not
  // CashSafeAccess — the caller is a cashier closing a till.
  GetRegisterSafeSummary: "/GetRegisterSafeSummary",
  // Till Cash Reconciliation: each drawer's GL balance vs the cash actually in it, the
  // 1114 residue, and each safe's ledger-vs-GL pair. Read-only diagnostic.
  GetTillCashDrift: "/GetTillCashDrift",
  ExportLedger: "/ExportLedger",
  ExportLedgerPdf: "/ExportLedgerPdf",
  // Counter Cash Safe (cashier door)
  GetReconcilableTxns: "/GetReconcilableTxns",
  ToggleCleared: "/ToggleCleared",
  BulkToggleCleared: "/BulkToggleCleared",
  Finalize: "/Finalize",
  Reopen: "/Reopen",
  ValidateInvoiceId: "/ValidateInvoiceId",
  GetSettings: "/GetSettings",
  PreviewTheme: "/PreviewTheme",
  ResetPassword: "/ResetPassword",
  SetPin: "/SetPin",
  ClearPin: "/ClearPin",
  Unblock: "/Unblock",
  IsUsernameExist: "/IsUsernameExist",
  ChangeStatus: "/ChangeStatus",
  UpdateStatus: "/UpdateStatus",
  ExportInquiries: "/ExportInquiries",
  RemoveBCST: "/RemoveBCST",
  GetDefaultMarkup: "/GetDefaultMarkup",
  UpdateBCST: "/UpdateBCST",
  DeleteSelectedProds: "/DeleteSelectedProds",
  UpdateProductsStatus: "/UpdateProductsStatus",
  UpdateProductsBaseUnit: "/UpdateProductsBaseUnit",
  UpdatePrices: "/UpdatePrices",
  ProductScanBySplr: "/ProductScanBySplr",
  ExportLabels: "/ExportLabels",
  GetLabels: "/GetLabels",
  GetAllByOrgPg: "/GetAllByOrgPg",
  GetAllByCoPg: "/GetAllByCoPg",
  GetByOutletPg: "/GetByOutletPg",
  ExportProducts: "/ExportProducts",
  StockReport: "/StockReport",
  AvgCostHistory: "/AvgCostHistory",
  ExportStockReport: "/ExportStockReport",
  ExportStockReportPdf: "/ExportStockReportPdf",
  ExportAvgCostHistory: "/ExportAvgCostHistory",
  ExportAvgCostHistoryPdf: "/ExportAvgCostHistoryPdf",
  LogReport: "/LogReport",
  ExportLogReport: "/ExportLogReport",
  ExportLogReportPdf: "/ExportLogReportPdf",
  GetAllByCo: "/GetAllByCo",
  // Paged + date-bounded sale returns. Replaces the unbounded GetAllByCo on the
  // Sale Returns screen.
  GetAllPg: "/GetAllPg",
  GetAllLabelByCo: "/GetAllLabelByCo",
  // Weighing scale setup
  GetConfig: "/GetConfig",
  SaveConfig: "/SaveConfig",
  GetAssignments: "/GetAssignments",
  SaveAssignment: "/SaveAssignment",
  // A location's print facts + picture sizes, for the invoice template designer
  GetPrintProfile: "/GetPrintProfile",
  PutPrintSizes: "/PutPrintSizes",
  DeployStatus: "/DeployStatus",
  TestScaleBarcode: "/Test",
  MarkVerified: "/MarkVerified",
  Search: "/Search",
  GetAll: "/GetAll",
  GetById: "/GetById",
  // Outlet: whether a repeat item gets its own cart line (Sales Invoice / Order).
  GetCartPolicy: "/GetCartPolicy",
  Post: "/Post",
  Put: "/Put",
  Delete: "/Delete",
  Duplicate: "/Duplicate",
  GetAuthUser: "/GetAuthUser",
  Login: "/Login",
  Logout: "/Logout",
  Forgot: "/Forgot",
  ChgPass: "/ChgPass",
  // Two-factor authentication
  TwoFactorVerify: "/TwoFactorVerify",
  TwoFactorResend: "/TwoFactorResend",
  TwoFactorUseEmail: "/TwoFactorUseEmail",
  // Self-service two-step, acting on the signed-in user's own account.
  MyTwoFactorStatus: "/MyTwoFactorStatus",
  MyTwoFactorStart: "/MyTwoFactorStart",
  MyTwoFactorConfirm: "/MyTwoFactorConfirm",
  MyTwoFactorDisable: "/MyTwoFactorDisable",
  MyTwoFactorForgetDevices: "/MyTwoFactorForgetDevices",
  ChangeOwnPassword: "/ChangeOwnPassword",
  SetMyPosScanMode: "/SetMyPosScanMode",
  TwoFactorEnrollStart: "/TwoFactorEnrollStart",
  TwoFactorEnrollConfirm: "/TwoFactorEnrollConfirm",
  GetEmailSetting: "/GetEmailSetting",
  SaveEmailSetting: "/SaveEmailSetting",
  SendTestEmail: "/SendTestEmail",
  GetTwoFactorPolicy: "/GetTwoFactorPolicy",
  SaveTwoFactorPolicy: "/SaveTwoFactorPolicy",
  // POST, not GET: API().get() appends a trailing "/" that corrupts a ?term query,
  // so the search term travels in the body.
  GetUsers: "/GetUsers",
  RequireTwoFactor: "/RequireTwoFactor",
  ResetTwoFactor: "/ResetTwoFactor",
  DisableTwoFactor: "/DisableTwoFactor",
  UnlockAccount: "/UnlockAccount",
  GetAllByOutlet: "/GetAllByOutlet",
  GetAllByOrg: "/GetAllByOrg",
  GetAuthUserOutlets: "/GetAuthUserOutlets",
  GetAuthUserOrg: "/GetAuthUserOrg",
  GetDocNumberSettings: "/GetDocNumberSettings",
  SaveDocNumberSettings: "/SaveDocNumberSettings",
  CheckCstmrCode: "/CheckCstmrCode",
  GetAllMainCatByOrg: "/GetAllMainCatByOrg",
  GetAllCatBySubcat: "/GetAllCatBySubcat",
  FindProducts: "/FindProducts",
  MarkAsReceived: "/MarkAsReceived",
  VoidOrder: "/VoidOrder",
  GetInventory: "/GetInventory",
  GetDetailsById: "/GetDetailsById",
  ReceiveDelivery: "/ReceiveDelivery",
  MarkStatusAsSent: "/MarkStatusAsSent",
  ActiveAndInactive: "/ActiveAndInactive",
  GetStockByProd: "/GetStockByProd",
  GetOutletsWithRegisters: "/GetOutletsWithRegisters",
  // What the register form's "create a GL account automatically" switch would mint.
  SuggestAccount: "/SuggestAccount",
  GetCashierOpenReg: "/GetCashierOpenReg",
  // "Given the till id I have cached, what may I actually work on right now?" — the
  // client's single source of truth for register state, re-asked on every load, tab
  // focus and cross-tab change. Route segments, not a query string: API().get()
  // appends a trailing "/" and a ?query would 400.
  ResolveActiveReg: "/ResolveActiveReg",
  CheckInvExist: "/CheckInvExist",
  GetActiveReg: "/GetActiveReg",
  GetLastClosingFloat: "/GetLastClosingFloat",
  // Everything the open-register form needs in ONE call: the suggested float, how much
  // the drawer is actually carrying over (the ceiling on "left in the drawer"), and the
  // safe to pre-select. Supersedes GetLastClosingFloat for the UI.
  GetOpenRegContext: "/GetOpenRegContext",
  ProductDetails: "/ProductDetails",
  GetAllByReg: "/GetAllByReg",
  RegSellWithPayType: "/RegSellWithPayType",
  PayTypeBreakdown: "/PayTypeBreakdown",
  // Supplier payments raised on a register session — the Z-report block. Display
  // only; the cash reconciliation gets its figures from the Expected math.
  SupplierPayments: "/SupplierPayments",
  CloseReg: "/CloseReg",
  Retrieve: "/Retrieve",
  GetByAuthUser: "/GetByAuthUser",
  SwitchUser: "/SwitchUser",
  CurrentMonthAndTodaySaleByUser: "/CurrentMonthAndTodaySaleByUser",
  ArchiveQuote: "/ArchiveQuote",
  GetAllByStatus: "/GetAllByStatus",
  GetCustomerAccounts: "/GetCustomerAccounts",
  GetByCustomer: "/GetByCustomer",
  GetAllByCustomer: "/GetAllByCustomer",
  GetAccountsByCustomer: "/GetAccountsByCustomer",
  CustomerDue: "/CustomerDue",
  PayBalance: "/PayBalance",
  GiveDiscount: "/GiveDiscount",
  VoidDiscount: "/VoidDiscount",
  // POS ▸ Collect Due ▸ Make Payment. Same payment engine as PayBalance, entered
  // through the till so the register session, outlet and cash safe are resolved
  // server-side rather than named by the client.
  PayAtPos: "/PayAtPos",
  ReversePayment: "/ReversePayment",
  // Drives what the POS Make Payment dialog may render — open register, whether the
  // outlet has a safe, and whether this profile may waive. Route segments, not a
  // query string: API().get() appends a trailing "/" and a ?query would 400.
  PosPayContext: "/PosPayContext",
  VoidPayment: "/VoidPayment",
  FindCustomer: "/FindCustomer",
  FilterSales: "/FilterSales",
  ValidateImportProduts: "/ValidateImportProduts",
  UploadProducts: "/UploadProducts",
  ImportProducts: "/ImportProducts",
  UploadCustomers: "/UploadCustomers",
  ExportCustomers: "/ExportCustomers",
  UploadSuppliers: "/UploadSuppliers",
  ExportSuppliers: "/ExportSuppliers",
  ImportCoas: "/ImportCoas",
  AttachCustomer: "/AttachCustomer",
  Void: "/Void",
  // Counter wastage — the cashier-scoped door onto InventoryAdjustment.
  PostWastage: "/PostWastage",
  GetWastageByReg: "/GetWastageByReg",
  // Inventory adjustment form: the cost + stock the post will use, per line.
  GetLineCosts: "/GetLineCosts",
  GetCostBreakdown: "/GetCostBreakdown",
  // "Recalculate cost" on the stock movements report.
  PreviewRecalc: "/PreviewRecalc",
  ApplyRecalc: "/ApplyRecalc",
  FindProdsBySplr: "/FindProdsBySplr",
  HaveMultipleOutlet: "/HaveMultipleOutlet",
  GetBySellId: "/GetBySellId",
  GetReturnsBySellId: "/GetReturnsBySellId",
  FinancialTotals: "/FinancialTotals",
  TopSellingProducts: "/TopSellingProducts",
  TopSellingCustomers: "/TopSellingCustomers",
  OutletSalesReport: "/OutletSalesReport",
  InventoryReport: "/InventoryReport",
  SyncProducts: "/SyncProducts",
  SyncInventory: "/SyncInventory",
  GetAllBySupplier: "/GetAllBySupplier",
  GetAccountsBySupplier: "/GetAccountsBySupplier",
  GetPaymentVoucher: "/GetPaymentVoucher",
  GetExpenseVoucher: "/GetExpenseVoucher",
  GetPaymentReceipt: "/GetPaymentReceipt",
  SearchUnpaidInvoices: "/SearchUnpaidInvoices",
  SearchUnpaidPurchaseInvoices: "/SearchUnpaidPurchaseInvoices",
  PostDraft: "/PostDraft",
  GetList: "/GetList",
  UninvoicedGrns: "/UninvoicedGrns",
  GenerateOrderNum: "/GenerateOrderNum",
  GetByOrderNo: "/GetByOrderNo",
  // Purchase Return source selection — resolves a typed PO / GRN / PINV number, lists a
  // supplier's returnable documents, and fetches one document's returnable lines.
  ResolveSource: "/ResolveSource",
  ReturnableDocuments: "/ReturnableDocuments",
  ReturnableLines: "/ReturnableLines",
  GetAllCatLabelByOrg: "/GetAllCatLabelByOrg",
  GetAllLabelByOrg: "/GetAllLabelByOrg",
  GetTotalRecordByOrg: "/GetTotalRecordByOrg",
  // Superseded by the PosCatalog pair below; removed once a build carrying the
  // category strip has shipped.
  GetProdsForPosBody: "/GetProdsForPosBody",
  // POS catalogue browse: the category strip, and the paged tiles behind it.
  GetCategoryStrip: "/GetCategoryStrip",
  GetTiles: "/GetTiles",
  // Browser-made POS thumbnails: the photos still without one, and the upload.
  MissingThumbs: "/MissingThumbs",
  UploadThumb: "/UploadThumb",
  GetServicesForPos: "/GetServicesForPos",
  FindEmployees: "/FindEmployees",
  FindBays: "/FindBays",
  FindProdFromPos: "/FindProdFromPos",
  ProdSelectForCart: "/ProdSelectForCart",
  // ProductPicker: one best-sellers-first page, and the cart payload for the ticked rows.
  ProductPickerPage: "/GetPage",
  ProductPickerCartItems: "/CartItems",
  // Sell/CheckStock — "would these cart lines fit?" before an add (useStockGate).
  CheckStock: "/CheckStock",
  ProductScan: "/ProductScan",
  ProfitAndLoss: "/ProfitAndLoss",
  ExportProfitAndLoss: "/ExportProfitAndLoss",
  SalesProfitSummary: "/SalesProfitSummary",
  CreditCustomer: "/CreditCustomer",
  ExportCreditCustomer: "/ExportCreditCustomer",
  ExportCreditCustomerPdf: "/ExportCreditCustomerPdf",
  ExportProductMovement: "/ExportProductMovement",
  ExportProductMovementPdf: "/ExportProductMovementPdf",
  ItemWiseSales: "/ItemWiseSales",
  ExportItemWiseSales: "/ExportItemWiseSales",
  ExportItemWiseSalesPdf: "/ExportItemWiseSalesPdf",
  ItemWiseSalesHistory: "/ItemWiseSalesHistory",
  ExportItemWiseSalesHistory: "/ExportItemWiseSalesHistory",
  CustomerItemHistoryPage: "/GetPage",
  CustomerWisePL: "/CustomerWisePL",
  ExportCustomerWisePL: "/ExportCustomerWisePL",
  ExportCustomerWisePLPdf: "/ExportCustomerWisePLPdf",
  ExpenseReport: "/ExpenseReport",
  ExportExpenseReport: "/ExportExpenseReport",
  ExportExpenseReportPdf: "/ExportExpenseReportPdf",
  ExpenseReportDetail: "/ExpenseReportDetail",
  ExportExpenseReportDetail: "/ExportExpenseReportDetail",
  ExportExpenseReportDetailPdf: "/ExportExpenseReportDetailPdf",
  // ---- Inventory Adjustment Report ----
  InventoryAdjustmentReport: "/InventoryAdjustmentReport",
  ExportInventoryAdjustmentReport: "/ExportInventoryAdjustmentReport",
  ExportInventoryAdjustmentReportPdf: "/ExportInventoryAdjustmentReportPdf",
  InventoryAdjustmentReportDetail: "/InventoryAdjustmentReportDetail",
  ExportInventoryAdjustmentReportDetail:
    "/ExportInventoryAdjustmentReportDetail",
  ExportInventoryAdjustmentReportDetailPdf:
    "/ExportInventoryAdjustmentReportDetailPdf",
  // Purchase Report (/purchase_report)
  PurchaseReport: "/PurchaseReport",
  ExportPurchaseReport: "/ExportPurchaseReport",
  ExportPurchaseReportPdf: "/ExportPurchaseReportPdf",
  PurchaseReportDetail: "/PurchaseReportDetail",
  ExportPurchaseReportDetail: "/ExportPurchaseReportDetail",
  ExportPurchaseReportDetailPdf: "/ExportPurchaseReportDetailPdf",
  PurchaseOpenOrders: "/PurchaseOpenOrders",
  ExportPurchaseOpenOrders: "/ExportPurchaseOpenOrders",
  ExportPurchaseOpenOrdersPdf: "/ExportPurchaseOpenOrdersPdf",
  PurchaseGrni: "/PurchaseGrni",
  ExportPurchaseGrni: "/ExportPurchaseGrni",
  ExportPurchaseGrniPdf: "/ExportPurchaseGrniPdf",
  PurchasePriceHistory: "/PurchasePriceHistory",
  ExportPurchasePriceHistory: "/ExportPurchasePriceHistory",
  ExportPurchasePriceHistoryPdf: "/ExportPurchasePriceHistoryPdf",
  PurchaseSupplierPerformance: "/PurchaseSupplierPerformance",
  ExportPurchaseSupplierPerformance: "/ExportPurchaseSupplierPerformance",
  ExportPurchaseSupplierPerformancePdf: "/ExportPurchaseSupplierPerformancePdf",
  ProfitByInvoice: "/ProfitByInvoice",
  ExportProfitByInvoice: "/ExportProfitByInvoice",
  ExportProfitByInvoicePdf: "/ExportProfitByInvoicePdf",
  InvoiceProfitDetail: "/InvoiceProfitDetail",
  FastMovingProds: "/FastMovingProds",
  SlowMovingProds: "/SlowMovingProds",
  TrialBalance: "/TrialBalance",
  ExportTrialBalance: "/ExportTrialBalance",
  BalanceSheet: "/BalanceSheet",
  ExportBalanceSheet: "/ExportBalanceSheet",
  ExportBalanceSheetPdf: "/ExportBalanceSheetPdf",
  TrialBalanceV2: "/TrialBalanceV2",
  ExportTrialBalanceV2: "/ExportTrialBalanceV2",
  ExportTrialBalanceV2Pdf: "/ExportTrialBalanceV2Pdf",
  GeneralLedger: "/GeneralLedger",
  ExportGeneralLedger: "/ExportGeneralLedger",
  ExportGeneralLedgerPdf: "/ExportGeneralLedgerPdf",
  GeneralLedgerAccount: "/GeneralLedgerAccount",
  JournalEntrySplit: "/JournalEntrySplit",
  ProfitAndLossV2: "/ProfitAndLossV2",
  ExportProfitAndLossV2: "/ExportProfitAndLossV2",
  ExportProfitAndLossV2Pdf: "/ExportProfitAndLossV2Pdf",
  SupplierAging: "/SupplierAging",
  SupplierAgingDetail: "/SupplierAgingDetail",
  ExportSupplierAging: "/ExportSupplierAging",
  ExportSupplierAgingPdf: "/ExportSupplierAgingPdf",
  CustomerAging: "/CustomerAging",
  CustomerAgingDetail: "/CustomerAgingDetail",
  ExportCustomerAging: "/ExportCustomerAging",
  ExportCustomerAgingPdf: "/ExportCustomerAgingPdf",
  GetProdDetailsForUpdatePrice: "/GetProdDetailsForUpdatePrice",
  PostDirectReturn: "/PostDirectReturn",
  GetCustomerPurchaseHistory: "/GetCustomerPurchaseHistory",
  ValidateProductSold: "/ValidateProductSold",
  EditSell: "/Edit",
  Reconcile: "/Reconcile",
  ReconcileByOutlet: "/ReconcileByOutlet",
  ReconcileByCompany: "/ReconcileByCompany",
  GetByProduct: "/GetByProduct",
  SyncStockPayments: "/SyncStockPayments",
  GetPlanByCompany: "/GetPlanByCompany",
  SavePlan: "/SavePlan",
  DeleteTier: "/DeleteTier",
  DeleteItemRate: "/DeleteItemRate",
  CalculateCommissions: "/CalculateCommissions",
  GetCommissionDetails: "/GetCommissionDetails",
  PayCommission: "/PayCommission",
  VoidCommissionPayment: "/VoidCommissionPayment",
  FinalizeTargetCommissions: "/FinalizeTargetCommissions",
  GetCommissionPaymentHistory: "/GetPaymentHistory",
  GetEmployeePayable: "/GetEmployeePayable",
  GetEmployeeProfileSummary: "/GetEmployeeProfileSummary",
  GetEmployeeCommissionLedger: "/GetEmployeeCommissionLedger",
  ExportEmployeeCommissionLedger: "/ExportEmployeeCommissionLedger",
  ExportCommissionReport: "/ExportCommissionReport",
  ExportCommissionReportPdf: "/ExportCommissionReportPdf",
  GetCompanyPayables: "/GetCompanyPayables",
  SearchLabels: "/SearchLabels",
  // Supplier picker ranked by outstanding balance (top 30) with the balance on
  // each option. Separate from SearchLabels because it aggregates supplier_txn —
  // the plain name picker shouldn't pay for a GROUP BY it doesn't need.
  SearchPayableLabels: "/SearchPayableLabels",
  // ---- Payment Report v2 ----
  GetPaymentsPg: "/GetPaymentsPg",
  GetPaymentDetail: "/GetPaymentDetail",
  // ---- Sales Summary ----
  GetSalesPg: "/GetSalesPg",
  GetSaleDetail: "/GetSaleDetail",
  // ---- Business Activity Dashboard ----
  GetSnapshot: "/GetSnapshot",
  // ---- Sales Invoice list dashboard tiles ----
  GetSummary: "/GetSummary",
  // ---- Promotion engine ----
  ExportExcel: "/ExportExcel",
  ExportPdf: "/ExportPdf",
  SetStatus: "/SetStatus",
  BulkGenerate: "/BulkGenerate",
  Validate: "/Validate",
  Redemptions: "/Redemptions",
  AuditLog: "/AuditLog",
  Dashboard: "/Dashboard",
  PerCoupon: "/PerCoupon",
  PerCustomer: "/PerCustomer",
  Pending: "/Pending",
  Approve: "/Approve",
  Reject: "/Reject",
  // Service Contracts (recurring service billing)
  GetBillings: "/GetBillings",
  GetDueBillings: "/GetDueBillings",
  GenerateNow: "/GenerateNow",
  PostBillings: "/PostBillings",
  DiscardBillings: "/DiscardBillings",
  Cancel: "/Cancel",
  Confirm: "/Confirm",
  GetInvoiceableById: "/GetInvoiceableById",
  GetInvoiceableList: "/GetInvoiceableList",
  // Installment
  Pay: "/Pay",
  Collect: "/Collect",
  GetCollectableById: "/GetCollectableById",
};

export const API = (endpoint) => {
  const url = BaseUrl + endpoint + "/";

  const get = async (onComplete) => {
    try {
      const { data } = await axios.get(url, { withCredentials: true });
      if (onComplete) return onComplete(data);
      return data;
    } catch (err) {
      console.error("Error: ", err);
      if (onComplete) return onComplete(undefined, err);
      throw err;
    }
  };

  const getById = async (id, onComplete) => {
    try {
      const { data } = await axios.get(url + id, { withCredentials: true });
      if (onComplete) return onComplete(data);
      return data;
    } catch (err) {
      console.error("Error: ", err);
      if (onComplete) return onComplete(undefined, err);
      throw err;
    }
  };

  const post = async (data, onComplete) => {
    try {
      const res = await axios.post(url, data, { withCredentials: true });
      if (onComplete) return onComplete(res.data);
      return res.data;
    } catch (err) {
      console.error("Error: ", err);
      if (onComplete) return onComplete(undefined, err);
      throw err;
    }
  };

  const put = async (data, onComplete) => {
    try {
      const res = await axios.put(url, data, { withCredentials: true });
      if (onComplete) return onComplete(res.data);
      return res.data;
    } catch (err) {
      console.error("Error: ", err);
      if (onComplete) return onComplete(undefined, err);
      throw err;
    }
  };

  const Delete = async (id, onComplete) => {
    try {
      const { data } = await axios.delete(url + id, { withCredentials: true });
      if (onComplete) return onComplete(data);
      return data;
    } catch (err) {
      console.error("Error: ", err);
      if (onComplete) return onComplete(undefined, err);
      throw err;
    }
  };

  const patchById = async (id, onComplete) => {
    try {
      const { data } = await axios.patch(url + id, null, {
        withCredentials: true,
      });
      if (onComplete) return onComplete(data);
      return data;
    } catch (err) {
      console.error("Error: ", err);
      if (onComplete) return onComplete(undefined, err);
      throw err;
    }
  };

  const postFile = async (data, onComplete) => {
    try {
      const res = await axios.post(url, data, {
        withCredentials: true,
        responseType: "blob",
      });
      if (onComplete) return onComplete(res);
      return res;
    } catch (err) {
      console.error("File download error:", err);
      if (onComplete) return onComplete(undefined, err);
      throw err;
    }
  };

  const getFileById = async (id, onComplete) => {
    try {
      const res = await axios.get(url + id, {
        withCredentials: true,
        responseType: "blob",
      });
      if (onComplete) return onComplete(res);
      return res;
    } catch (err) {
      console.error("File download error:", err);
      if (onComplete) return onComplete(undefined, err);
      throw err;
    }
  };

  return {
    get,
    getById,
    post,
    put,
    Delete,
    patchById,
    postFile,
    getFileById,
  };
};
